import { useMemo } from "react";
import { useQuery } from "@apollo/client";
import { HgProductCategory } from "../../../../types/taxonomy";
import { ProductCategoryQueryPayload } from "../../../../legacy/types/companySearch/MI";
import { PRODUCT_CATEGORY_QUERY } from "../../../../apis/taxonomy/queries";
import { TAXONOMY_CLIENT } from "../../../../utils/consts";

interface ProductCategory {
  loading: boolean;
  productCategoryData: HgProductCategory[];
  productCategoryMap: Record<string, HgProductCategory>;
}

/**
 * Fetches product category data
 * @example
 *  const { loading, productCategoryData } = useProductCategory();
 *
 * @returns { ProductCategory }
 *  Product category data
 */

export default function useProductCategory(): ProductCategory {
  const { loading, data } = useQuery<ProductCategoryQueryPayload>(
    PRODUCT_CATEGORY_QUERY,
    {
      context: {
        clientName: TAXONOMY_CLIENT,
      },
    }
  );

  const productCategoryData = useMemo(() => data?.category?.data ?? [], [data]);

  const productCategoryMap = useMemo(() => {
    const map: ProductCategory["productCategoryMap"] = {};

    for (const productCategory of productCategoryData) {
      map[productCategory.id] = productCategory;
    }

    return map;
  }, [productCategoryData]);

  return {
    loading,
    productCategoryData,
    productCategoryMap,
  };
}
